module.exports = __webpack_public_path__ + "static/media/cake_slice.b62a3b4e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@zola/zola-ui/src/assets/images/icons/cake_slice.svg
// module id = 1884
// module chunks = 51